import { OnsiteInjectionDto } from "@intelligems/ig-types";
import * as rtk from "@reduxjs/toolkit";
import { type PayloadAction, createSelector } from "@reduxjs/toolkit";

import { VariationFe } from "../../types/schemas/variations";
import { IOnsiteInjectionsState } from "../types/onsiteInjections";
import { IAppState } from "../types/store";

const sliceInitialOnsiteInjectionsState: IOnsiteInjectionsState = {
  isSuccess: false,
  injections: [],
  storedInjections: [],
};

const onsiteInjections = rtk.createSlice({
  name: "onsiteInjections",
  initialState: sliceInitialOnsiteInjectionsState,
  reducers: {
    resetOnsiteInjections: (draft) => {
      draft = sliceInitialOnsiteInjectionsState;
      return draft;
    },
    modClearOnsiteInjection: (draft) => {
      draft = { ...draft, injections: [] };
      return draft;
    },
    initOnsiteInjections: (
      draft,
      action: PayloadAction<OnsiteInjectionDto[]>
    ) => {
      draft.isSuccess;
      draft.injections = action.payload;
      draft.storedInjections = action.payload;
    },
    initNewPersonalizationOnsiteInjections: (
      draft,
      action: PayloadAction<VariationFe>
    ) => {
      draft.isSuccess;
      draft.injections.push({
        variationId: action.payload.id,
        customCss: "",
        customJs: "",
      });
      return draft;
    },
    setSelectedVariationInjection: (
      draft,
      action: PayloadAction<{
        variationId: string;
        type: "customCss" | "customJs";
        value: string;
      }>
    ) => {
      const index = draft.injections.findIndex(
        (injection) => injection.variationId === action.payload.variationId
      );
      if (index !== -1) {
        draft.injections[index][action.payload.type] = action.payload.value;
      } else {
        draft.injections.push({
          variationId: action.payload.variationId,
          customJs:
            action.payload.type === "customCss"
              ? undefined
              : action.payload.value,
          customCss:
            action.payload.type === "customJs"
              ? undefined
              : action.payload.value,
        });
      }
      return draft;
    },
  },
  selectors: {
    selectedInjections: (state) => state.injections,
    selectedInjectionsState: (state) => state as IOnsiteInjectionsState,
  },
});

export const {
  resetOnsiteInjections,
  setSelectedVariationInjection,
  initOnsiteInjections,
  initNewPersonalizationOnsiteInjections,
  modClearOnsiteInjection,
} = onsiteInjections.actions;

export const onsiteInjectionsReducer = onsiteInjections.reducer;
export const { selectedInjections, selectedInjectionsState } =
  onsiteInjections.selectors;
